<div class="flex flex-col gap-2">
  <barcode-scanner-search-field (onCode)="codeScanned($event)"></barcode-scanner-search-field>

  <div class="flex flex-col gap-2 rounded-sm">
    @for (code of barcodes(); track $index; let i = $index) {
      <div class="rounded-sm bg-neutral-800 mt-2 mb-2">
        <p-floatlabel variant="on">
          <p-iconfield>
            <input
              class="w-full"
              type="text"
              pInputText
              [ngModel]="barcodes()[i]"
              (keyup)="setBarcodeText(i, $event.target.value)"
            />
            <p-inputicon class="cursor-pointer" (click)="removeBarcode(i)">
              <mat-icon>close</mat-icon>
            </p-inputicon>
          </p-iconfield>
          <label>{{ 'internal.inventory.itemEdit.barcode' | translate }}</label>
        </p-floatlabel>
      </div>
    }
  </div>
</div>

<div class="flex justify-end gap-2 mt-4">
  <p-button
    [label]="'general.close' | translate"
    severity="secondary"
    (onClick)="dialogRef.close(null)"
  />
  <p-button [label]="'general.save' | translate" severity="primary" (onClick)="save()" />
</div>
